import type { ReactNode } from "react";
import type { Tone } from "../lib/labels";
import { errorText } from "../lib/labels";

export function Badge({ tone = "", children }: { tone?: Tone; children: ReactNode }) {
  return <span className={`pf-badge${tone ? ` pf-badge--${tone}` : ""}`}>{children}</span>;
}

export function Note({ tone = "", children }: { tone?: Tone; children: ReactNode }) {
  return <div className={`pf-note${tone ? ` pf-note--${tone}` : ""}`}>{children}</div>;
}

/**
 * Ein Balken 0–100. Die Breite setzt React über das CSSOM (`style`-Prop) —
 * die CSP der Plattform (`style-src 'self'`) verbietet `style="…"` im
 * ausgelieferten Markup, nicht aber das.
 */
export function Meter({ pct, tone = "" }: { pct: number; tone?: Tone }) {
  const p = Math.max(0, Math.min(100, Number(pct) || 0));
  return (
    <div className={`pf-meter${tone ? ` pf-meter--${tone}` : ""}`} role="meter" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(p)}>
      <span style={{ width: `${p.toFixed(1)}%` }} />
    </div>
  );
}

export function Loading({ text = "Wird geladen …" }: { text?: string }) {
  return <div className="pf-empty">{text}</div>;
}

/** Ein Fehler als Satz (`errorText`) in einem roten Hinweis. */
export function ErrorNote({ error }: { error: unknown }) {
  return <Note tone="error">{errorText(error)}</Note>;
}
